import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100 py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">

        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 mb-12">

          {/* Brand + tagline */}
          <div className="max-w-xs">
            <Link
              to="/"
              className="font-playfair text-lg text-charcoal tracking-wide hover:text-bronze transition-colors duration-300 block mb-3"
              style={{ fontFamily: '"Playfair Display", Georgia, serif' }}
            >
              Dhrumil Desai Photography
            </Link>
            <p
              className="text-sm font-inter font-light text-gray-500 leading-relaxed"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Capturing love and telling stories across New Zealand, from Christchurch and beyond.
            </p>
          </div>

          {/* Nav links */}
          <nav className="flex flex-col gap-3" aria-label="Footer navigation">
            <p
              className="text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-1 font-inter"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Navigate
            </p>
            {[
              { path: '/', label: 'Home' },
              { path: '/services', label: 'Services' },
              { path: '/portfolio', label: 'Portfolio' },
              { path: '/contact', label: 'Contact' },
            ].map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className="text-xs tracking-[0.15em] uppercase font-inter text-charcoal hover:text-bronze transition-colors duration-200"
                style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* Contact info */}
          <div className="flex flex-col gap-3">
            <p
              className="text-[10px] tracking-[0.3em] uppercase text-gray-400 mb-1 font-inter"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Get in Touch
            </p>
            <a
              href="mailto:hello@dhrumildesai.co.nz"
              className="text-xs tracking-[0.05em] font-inter text-charcoal hover:text-bronze transition-colors duration-200"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              hello@dhrumildesai.co.nz
            </a>
            <p
              className="text-xs tracking-[0.05em] font-inter text-gray-500"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Christchurch, New Zealand
            </p>
            <p
              className="text-xs tracking-[0.05em] font-inter text-gray-500"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Available NZ Wide
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p
            className="text-[11px] text-gray-400 font-inter"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            &copy; {year} Dhrumil Desai Photography. All rights reserved.
          </p>
          <Link
            to="/contact"
            className="text-[11px] tracking-[0.2em] uppercase font-inter text-bronze border-b border-bronze pb-0.5 hover:text-charcoal hover:border-charcoal transition-colors duration-200 self-start md:self-auto"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Book a Session
          </Link>
        </div>

      </div>
    </footer>
  );
}
